// cloneDeep.ts
function cloneDeep(val, instanceClone) {
    if (Array.isArray(val)) {
        return cloneArrayDeep(val, instanceClone);
    }
    else if (isPlainObject(val)) {
        return cloneObjectDeep(val, instanceClone);
    }
    return clone(val);
}
function cloneObjectDeep(val, instanceClone) {
    if (typeof instanceClone === 'function') {
        return instanceClone(val);
    }
    const res = {};
    for (const key in val) {
        if (Object.prototype.hasOwnProperty.call(val, key)) {
            res[key] = cloneDeep(val[key], instanceClone);
        }
    }
    return res;
}
function cloneArrayDeep(val, instanceClone) {
    const res = new Array(val.length);
    for (let i = 0; i < val.length; i++) {
        res[i] = cloneDeep(val[i], instanceClone);
    }
    return res;
}
function clone(val) {
    const type = getType(val);
    switch (type) {
        case 'array':
            return val.slice();
        case 'object':
            return Object.assign({}, val);
        case 'date':
            return new Date(val.getTime());
        case 'map':
            return new Map(val);
        case 'set':
            return new Set(val);
        case 'regexp':
            return new RegExp(val.source, val.flags);
        case 'error':
            if (typeof val === 'object' && val !== null) {
                return Object.create(val);
            }
            return val;
        default:
            return val;
    }
}
function getType(val) {
    if (val === null)
        return 'null';
    if (Array.isArray(val))
        return 'array';
    if (val instanceof Date)
        return 'date';
    if (val instanceof Map)
        return 'map';
    if (val instanceof Set)
        return 'set';
    if (val instanceof RegExp)
        return 'regexp';
    if (typeof val === 'object')
        return 'object';
    return typeof val;
}
function isPlainObject(val) {
    if (typeof val !== 'object' || val === null)
        return false;
    const proto = Object.getPrototypeOf(val);
    return proto === Object.prototype || proto === null;
}
// Export cloneDeep
export default cloneDeep;
